const ObjectToString = (obj: any): string => {
  return Object.entries(obj)
    .map(([name, value]) => {
      if (typeof value === "string" || typeof value === "number") {
        return `${name}=${JSON.stringify(value)}`;
      }
      if (typeof value === "object") {
        return `${name}=${JSON.stringify(ObjectToString(value))}`;
      }
      return null;
    })
    .filter((value) => value !== null)
    .join(",");
};
export default ObjectToString;
